function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.439 19.965l-1.823 2.187L.501 11.219 9.616.286l1.823 2.187-7.235 8.746 7.235 8.746z",
  fill: "#fff"
});

function SvgArrowLeftCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgArrowLeftCalendar;